(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dd-collection-card-help"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dd-collection-buy')){
    customElements.define('dd-collection-buy',class extends HTMLElement{
      connectedCallback(){
        if(this.dataset.ready)return;
        this.dataset.ready='true';
        const form=this.querySelector('form');
        const select=form.querySelector('select[name="id"]');
        const quantity=form.querySelector('input[name="quantity"]');
        const button=form.querySelector('button[type="submit"]');
        const buttonLabel=button.querySelector('[data-button-label]');
        const status=this.querySelector('[role="status"]');
        const cartLink=this.querySelector('.dd-collection-buy__cart');
        const card=this.closest('product-card,article');
        let busy=false;
        const sync=()=>{
          const option=select.selectedOptions[0];
          if(!option)return;
          const price=card?.querySelector('[data-dd-direct-price]');
          if(price)price.textContent=option.dataset.price;
          for(const link of card?.querySelectorAll('a[ref="productCardLink"],a[ref="cardGalleryLink"],a[ref="productTitleLink"],.dd-collection-buy__details')||[])link.href=option.dataset.url;
          quantity.min=option.dataset.min||'1';
          quantity.step=option.dataset.step||'1';
          if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');
          if(!quantity.validity.valid)quantity.value=quantity.min;
          button.disabled=option.disabled;
          buttonLabel.textContent=option.disabled?this.dataset.unavailable:this.dataset.add;
        };
        select.addEventListener('change',()=>{sync();status.hidden=true;cartLink.hidden=true;});
        sync();
        form.addEventListener('submit',async event=>{
          event.preventDefault();
          if(busy||!form.reportValidity()||select.selectedOptions[0]?.disabled)return;
          busy=true;
          const payload=new FormData(form);
          payload.delete('return_to');
          const pack=select.selectedOptions[0].textContent.trim();
          const amount=quantity.value;
          button.disabled=true;select.disabled=true;quantity.disabled=true;
          form.setAttribute('aria-busy','true');
          buttonLabel.textContent=this.dataset.adding;
          status.hidden=true;cartLink.hidden=true;
          try{
            const response=await fetch(form.action.replace(/\/$/,'')+'.js',{method:'POST',body:payload,headers:{Accept:'application/json'},credentials:'same-origin'});
            const result=await response.json();
            if(!response.ok){status.textContent=typeof result.description==='string'?result.description:this.dataset.error;}
            else{
              status.textContent=this.dataset.added+' '+amount+' × '+pack;
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }
          }catch(error){status.textContent=this.dataset.error;}
          finally{
            status.hidden=false;cartLink.hidden=false;
            busy=false;select.disabled=false;quantity.disabled=false;
            form.removeAttribute('aria-busy');sync();
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
